import { createLucideIcon } from './lucideIcon'

export const ArrowLeft = createLucideIcon(
  'ArrowLeft',
  <>
    <path d="m12 19-7-7 7-7" />
    <path d="M19 12H5" />
  </>
)
